// src/components/copilot/ChatLoadingIndicator.jsx
import { Box, Paper, Typography } from "@mui/material";
import { memo } from "react";

const ChatLoadingIndicator = memo(() => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
      <Paper elevation={1} sx={{ p: 2, bgcolor: "white" }}>
        <Typography variant="body2" color="text.secondary">
          Thinking...
        </Typography>
      </Paper>
    </Box>
  );
});

ChatLoadingIndicator.displayName = "ChatLoadingIndicator";

export default ChatLoadingIndicator;
